import { __extends } from "tslib";
import { Debug } from '@awayjs/core';
import { TextField, DisplayObjectContainer as AwayDisplayObjectContainer, TextFieldAutoSize } from '@awayjs/scene';
import { DisplayObjectContainer } from '../../display/DisplayObjectContainer';
import { TextBaseline } from './TextBaseline';
import { TextLineValidity } from './TextLineValidity';
var noLogs = true;
var TextLine = /** @class */ (function (_super) {
    __extends(TextLine, _super);
    function TextLine(previousLine, width, lineOffset, fitSomething, text, formats, formatsIndices, textBlockBeginIndex, textLength, elementsFormats) {
        var _this = _super.call(this) || this;
        var adaptee = new AwayDisplayObjectContainer();
        _this.adaptee = adaptee;
        _this._previousLine = previousLine;
        if (previousLine) {
            previousLine.setNextLine(_this);
        }
        _this._width = width;
        _this._textWidth = 0;
        _this._textHeight = 0;
        _this._lineOffset = lineOffset;
        _this._fitSomething = fitSomething;
        _this._rawText = text ? text : '';
        _this._textFormatsIndices = formatsIndices;
        _this._textFormats = formats;
        _this._textLength = textLength;
        _this._textBlockBeginIndex = textBlockBeginIndex;
        _this._specifiedWidth = _this._width;
        _this._textfield = new TextField();
        _this.initTextline(elementsFormats);
        noLogs || console.log('[TextLine] ' + _this.adaptee.id + ' textfield:', _this._textfield, '\n		previousLine', previousLine, '\n		width', width, '\n		lineOffset', lineOffset, '\n		fitSomething', fitSomething, '\n		text', text, '\n		formats', formats, '\n		formatsIndices', formatsIndices, '\n		textBlockBeginIndex', textBlockBeginIndex, '\n		textLength', textLength, '\n		_ascent', _this._ascent, '\n		_descent', _this._descent, '\n		newTextField.textWidth', _this._textfield.textWidth);
        return _this;
    }
    TextLine.prototype.initTextline = function (elementsFormats) {
        this._ascent = 0;
        this._descent = Number.POSITIVE_INFINITY;
        this._textfield.multiline = false;
        this._textfield.border = false;
        this._textfield.wordWrap = false;
        var defaultFormat = this._textFormats[0];
        var defaultElementFormat = elementsFormats[0];
        var lastAlignmentBaseline = defaultElementFormat.getBaseline();
        this.adaptee.addChild(this._textfield);
        if (this._rawText !== '') {
            this._textfield.autoSize = TextFieldAutoSize.LEFT;
            this._textfield.text = this._rawText;
            var startIdx = 0;
            for (var i = 0; i < this._textFormatsIndices.length; i++) {
                var textFormat = this._textFormats[i];
                var elementFormat = elementsFormats[i];
                if (lastAlignmentBaseline != elementFormat.getBaseline()) {
                    console.warn('[TextLine] - one Textline with different alignmentBaseline');
                }
                var endIdx = this._textFormatsIndices[i];
                var ascent = textFormat.font_table.ascent;
                var descent = textFormat.font_table.descent;
                var em_size = textFormat.font_table.get_font_em_size();
                ascent = (ascent / em_size) * textFormat.size;
                descent = (descent / em_size) * textFormat.size;
                /*console.log("em_size", em_size);
                console.log("ascent", ascent);
                console.log("descent", descent);
                console.log("both", ascent + descent);*/
                if (this._ascent < ascent) {
                    this._ascent = ascent;
                }
                if (this._descent > descent) {
                    this._descent = descent;
                }
                !this._textfield || this._textfield.setTextFormat(textFormat, startIdx, endIdx);
                startIdx = endIdx;
                this._textfield.height = this._ascent - this._descent;
            }
        }
        else {
            this._textfield.autoSize = TextFieldAutoSize.NONE;
            this._ascent = defaultFormat.font_table.ascent;
            this._descent = defaultFormat.font_table.descent;
            var em_size = defaultFormat.font_table.get_font_em_size();
            this._ascent = (this._ascent / em_size) * defaultFormat.size;
            this._descent = (this._descent / em_size) * defaultFormat.size;
            this._textfield.width = 10;
            this._textfield.height = this._ascent - this._descent;
        }
        this._textWidth = this._textfield ? this._textfield.textWidth + 4 : 10;
        this._unjustifiedTextWidth = this._textWidth;
        noLogs || console.log('[TextLine]', this._rawText.length, lastAlignmentBaseline, this._ascent, this._descent);
        this._descent = Math.abs(this._descent);
        this._ascent += 1;
        if (lastAlignmentBaseline == TextBaseline.ROMAN) {
            this._textfield.y = -(this._ascent); // - this._descent);
        }
        else if (lastAlignmentBaseline == TextBaseline.ASCENT) {
            this._textfield.y = -(this._ascent - this._descent) - this._ascent - this._descent;
        }
        else {
            console.warn('[TextLine] - unsupported alignmentBaseline', lastAlignmentBaseline);
            this._textfield.y = -(this._ascent - this._descent) - this._ascent;
        }
        this._textfield.x = 0;
        this._ascent = this._ascent - this._descent;
        //this._forceWidth = this._ascent + this._descent;
        //this._forceHeight = this._ascent - this._descent;
        //this._forceHeight = 200;//Math.ceil(this._forceHeight * 20) / 20;
        /*if (lineOffset == 0 && previousLine && previousLine._lineOffset) {
            lineOffset = previousLine._lineOffset;
        }*/
        noLogs || console.log('[TextLine] ' + this.adaptee.id, '_rawText', this._rawText);
        this._validity = TextLineValidity.VALID;
    };
    TextLine.prototype.reUseTextLine = function (previousLine, width, lineOffset, fitSomething, text, formats, formatsIndices, textBlockBeginIndex, textLength, elementsFormats) {
        this.adaptee.x = 0;
        this.adaptee.y = 0;
        this._previousLine = previousLine;
        if (previousLine) {
            previousLine.setNextLine(this);
        }
        this._width = width;
        this._textWidth = 0;
        this._textHeight = 0;
        this._lineOffset = lineOffset;
        this._fitSomething = fitSomething;
        this._rawText = text ? text : '';
        this._textFormatsIndices = formatsIndices;
        this._textFormats = formats;
        this._textLength = textLength;
        this._textBlockBeginIndex = textBlockBeginIndex;
        this._specifiedWidth = this._width;
        this._textfield.reset();
        this._textfield.text = '';
        this.initTextline(elementsFormats);
    };
    TextLine.prototype.getBaselinePosition = function (baseline) {
        noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - getBaselinePosition', baseline);
        switch (baseline) {
            case TextBaseline.ROMAN:
                // does not seem to matter what we return here
                // for each TLF it checks 2 times for this value,
                // and than 1 time for the ASCENT value
                return -(this._ascent + this._descent);
            case TextBaseline.ASCENT:
                return -(this._ascent); // + this._descent);
        }
        return 0;
    };
    TextLine.prototype.setNextLine = function (value) {
        noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - setNextLine', value);
        this._nextLine = value;
    };
    TextLine.prototype.setPreviousLine = function (value) {
        noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get previousLine', this._previousLine);
        this._previousLine = value;
    };
    TextLine.prototype.setTextBlock = function (value) {
        noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - setTextBlock', value);
        this._textBlock = value;
    };
    TextLine.prototype.getMirrorRegion = function (mirror) {
        noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - getMirrorRegion', mirror);
        return null;
    };
    TextLine.prototype.flushAtomData = function () {
        noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - flushAtomData');
    };
    Object.defineProperty(TextLine.prototype, "textBlock", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get textBlock', this._textBlock);
            return this._textBlock;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "hasGraphicElement", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get hasGraphicElement');
            return false; //this._hasGraphicElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "hasTabs", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get hasTabs', this._hasTabs);
            return false; //this._hasTabs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "nextLine", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get nextLine', this._nextLine);
            return this._nextLine;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "previousLine", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get previousLine', this._previousLine);
            return this._previousLine;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "ascent", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get ascent', this._ascent);
            return 0; //this._ascent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "descent", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get descent', this._descent);
            return 0; //this._descent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "textHeight", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get textHeight', this._ascent + this._descent);
            return this._ascent + this._descent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "textWidth", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get textWidth', this._textWidth);
            return this._textWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "totalAscent", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get totalAscent', this._ascent);
            return this._ascent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "totalDescent", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get totalDescent', this._descent);
            return this._descent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "totalHeight", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get totalHeight', this._ascent + this._descent);
            return this._ascent + this._descent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "textBlockBeginIndex", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get textBlockBeginIndex', this._textBlockBeginIndex);
            return this._textBlockBeginIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "rawTextLength", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get rawTextLength', this._textLength);
            return this._textLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "specifiedWidth", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get specifiedWidth', this._specifiedWidth);
            return this._specifiedWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "unjustifiedTextWidth", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get unjustifiedTextWidth', this._unjustifiedTextWidth);
            return this._unjustifiedTextWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "validity", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get validity', this._validity);
            return this._validity;
        },
        set: function (value) {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - set validity', value);
            this._validity = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "atomCount", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get atomCount', this._textLength);
            return this._textLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "mirrorRegions", {
        get: function () {
            noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - get mirrorRegions', this._mirrorRegions);
            return this._mirrorRegions;
        },
        enumerable: false,
        configurable: true
    });
    TextLine.prototype.getAtomIndexAtPoint = function (stageX, stageY) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomIndexAtPoint', '');
        return null;
    };
    TextLine.prototype.getAtomIndexAtCharIndex = function (charIndex /*int*/) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomIndexAtCharIndex', '');
        return charIndex;
    };
    TextLine.prototype.getAtomBounds = function (atomIndex /*int*/) {
        var bounds = this._textfield.getCharBoundaries(atomIndex);
        noLogs || console.log('[TextLine] ' + this.adaptee.id + ' - getAtomBounds', 'atomIndex', atomIndex, 'bounds', bounds);
        return this.sec.flash.geom.Rectangle(bounds.x, bounds.y, bounds.width, this._ascent + this.descent);
    };
    TextLine.prototype.getAtomBidiLevel = function (atomIndex /*int*/) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomBidiLevel', '');
        return null;
    };
    TextLine.prototype.getAtomTextRotation = function (atomIndex /*int*/) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomTextRotation', '');
        return null;
    };
    TextLine.prototype.getAtomTextBlockBeginIndex = function (atomIndex /*int*/) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomTextBlockBeginIndex', '');
        return null;
    };
    TextLine.prototype.getAtomTextBlockEndIndex = function (atomIndex /*int*/) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomTextBlockEndIndex', '');
        return null;
    };
    TextLine.prototype.getAtomCenter = function (atomIndex /*int*/) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomCenter', '');
        return null;
    };
    TextLine.prototype.getAtomWordBoundaryOnLeft = function (atomIndex /*int*/) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomWordBoundaryOnLeft', '');
        return null;
    };
    TextLine.prototype.getAtomGraphic = function (atomIndex /*int*/) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'getAtomGraphic', '');
        return null;
    };
    TextLine.prototype.dump = function () {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextLine', 'dump', '');
        return null;
    };
    TextLine.forceNativeConstructor = true;
    TextLine.forceNativeMethods = true;
    TextLine.MAX_LINE_WIDTH = 1000000;
    return TextLine;
}(DisplayObjectContainer));
export { TextLine };
